export const environment = {
  production: false,
  appConfig: 'stage.appconfig.json'
};
